import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: false,
            showVariant: true,
            showPackage: false,
            showStartDateWithTime: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showLinkedCards: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
